const baseApiUrl = 'https://noprod-taa-privatschutz-2-0-fcp-europe-public.apis.allianz.com/';
const bffPath = '/v1';
const configMap: Record<string, string> = {
  'https://privatschutz-dev.allianz.de': 'dev',
  'https://privatschutz-devnext.allianz.de': 'devnext',
  'https://privatschutz-uat.allianz.de': 'uat',
  'http://localhost:10000': 'uat',
  'https://privatschutz-uatnext.allianz.de': 'uatnext',
  'https://privatschutz-fix.allianz.de': 'fix',
  'https://privatschutz-lab.allianz.de': 'lab',
  'https://privatschutz-edu.allianz.de': 'edu',
  'https://privatschutz-si.allianz.de': 'si',
};
const clientIdMap = {
  dev: 'NAJjMldWWAAJ3eQ2nPHNASJdwUyA9V4B',
  devnext: 'kgIFro9ZoNahZA8p1xCE8Dlr1kQTMMKs',
  uat: 'VPa6x2SEKKPG9tK4KU0L5GbfhAO0uAns',
  uatnext: '4VnJj1Inz3CytA9N0ptgBoUU2bQBF7K4',
  fix: '9XU3Mdina0vIWWJsJFyKso8O5fqDjbXF',
  lab: 'yZ6sFgohwUfgIe1QAoAoztVtP1cO0g1s',
  edu: '8zR4EdohjS63T6BIC7Mf1YuUQAG2mCGG',
  si: 'AinvojD8SCCFJsBIsI1dCA8ReEvxxZzs',
};

export function getClientIdForStage(origin: string = window.location.origin): string {
  const environment = configMap[origin];
  return (clientIdMap as Record<string, string>)[environment];
}

export function getBffBaseUrlForStage(origin: string = window.location.origin): string {
  const environment = configMap[origin];
  return `${baseApiUrl}ps20-${environment}${bffPath}`;
}

export const clientIdForStage = getClientIdForStage();
export const bffBaseUrlForStage = getBffBaseUrlForStage();
